export const ParseDailyEnergyConstraint = value => Number(value);
